module.exports = __webpack_public_path__ + "img/1.36b2db3c.jpeg";